function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9999 8.18002C15.9999 7.65335 15.9522 7.15335 15.8705 6.66669H8.17358V9.67336H12.5806C12.383 10.66 11.8041 11.4934 10.9458 12.06V14.06H13.575C15.1144 12.6667 15.9999 10.6134 15.9999 8.18002Z",
  fill: "#4285F4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.17368 16C10.3806 16 12.2265 15.28 13.5751 14.06L10.9459 12.06C10.2103 12.54 9.27713 12.8333 8.17368 12.8333C6.04171 12.8333 4.23669 11.4267 3.5896 9.52667H0.878662V11.5867C2.22051 14.2 4.97913 16 8.17368 16Z",
  fill: "#34A853"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M3.58961 9.52666C3.41933 9.04666 3.33078 8.53333 3.33078 8C3.33078 7.46666 3.42614 6.95333 3.58961 6.47333V4.41333H0.878671C0.320136 5.49333 0 6.70666 0 8C0 9.29333 0.320136 10.5067 0.878671 11.5867L3.58961 9.52666Z",
  fill: "#FBBC05"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8.17368 3.16667C9.3793 3.16667 10.4555 3.57334 11.3069 4.36667L13.6364 2.08667C12.2265 0.793334 10.3806 0 8.17368 0C4.97913 0 2.22051 1.8 0.878662 4.41334L3.5896 6.47334C4.23669 4.57334 6.04171 3.16667 8.17368 3.16667Z",
  fill: "#EA4335"
});

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.c9e9b30c.svg";
export { ForwardRef as ReactComponent };